export enum MessagesContentTab {
  SEQUENCES = 0,
  SCRIPTS = 1,
  CONTENTS = 2,
}
